export default "__VITE_ASSET__Dw2EfDTF__"